import { useMemo } from 'react'
import {
  GridApi,
  GridColumnsState,
  gridColumnFieldsSelector,
  gridColumnLookupSelector,
  gridColumnVisibilityModelSelector,
} from '@mui/x-data-grid-pro'

export const useFilteredGridColumns = (
  apiRef: React.MutableRefObject<GridApi>,
): GridColumnsState => {
  const internalColumns = gridColumnFieldsSelector(apiRef)
  const lookup = gridColumnLookupSelector(apiRef)
  const columnVisibilityModel = gridColumnVisibilityModelSelector(apiRef)

  const orderedFields = useMemo(
    () => internalColumns.filter((c) => !c.startsWith('__')),
    [internalColumns],
  )

  return { orderedFields, lookup, columnVisibilityModel }
}
